import { GET_BILLING_TABLE_DATA, SET_BILLING_TABLE_STATUS } from '../helpers/types';

const INITIAL_STATE = {
  billingDataArr: [],
  isLoading: false,
  top: 20,
  listCount: null,
  failText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_BILLING_TABLE_DATA:
      return {
        ...state,
        billingDataArr: action.payload.data,
        isLoading: false,
        listCount: action.payload.listCount,
      };
    case SET_BILLING_TABLE_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
